import React, { useEffect, useState } from 'react';
import Autoplay from 'embla-carousel-autoplay';
import useEmblaCarousel from 'embla-carousel-react';
import './embla.css';
import { getCachedMediaUrl } from '../../../../../../lib/utils/utils';
import { DotButton, useDotButton } from './EmblaCarouselDotButton';
import EditPencil from '../../../../../../Assets/StorefrontIcons/EditPencil.svg';
import ArrowUp from '../../../../../../Assets/StorefrontIcons/ArrowUp.svg';
import { useDispatch, useSelector } from 'react-redux';
import { moveSectionDown, moveSectionUp, removeSection, setSectionFormType, setSectionType } from '../../../../../../Features/storefrontSlice';
import { showToast } from '../../../../../../Components/Toaster/Toaster';
import Delete from '../../../../../../Assets/DeleteRed.svg';

Autoplay.globalOptions = {
    delay: 8000
}

function CarouselBannerDesktop({ item, options }) {
    const dispatch = useDispatch();
    const [buttonsVisible, setButtonsVisible] = useState(false);
    const [hoverOnBox, setHoverOnBox] = useState(false);

    const versionStack = useSelector((state) => state.storefront.versionStack);
    const versionIndex = useSelector((state) => state.storefront.versionIndex);

    const mobileItem = versionStack[versionIndex]?.versionData.find(section => section.item.typeData === item.item.typeData);

    const [emblaRef, emblaApi] = useEmblaCarousel(options, [Autoplay()]);

    const { selectedIndex, scrollSnaps } = useDotButton(
        emblaApi,
    );

    useEffect(() => {
        if(hoverOnBox) {
            setButtonsVisible(true);
        } else {
            setButtonsVisible(false);
        }
    }, [hoverOnBox]);

    function handleEditClick() {
        dispatch(setSectionType('SECTION'));
        dispatch(setSectionFormType('CAROUSEL_BANNER_DESKTOP'));
    }
    
    function handleUpClick() {
        if(item.prev) {
            dispatch(moveSectionUp({ item, mobileItem }));
        }
        else {
            showToast('Action failed!', 'warning');
        }
    }

    function handleDownClick() {
        if(item.next) {
            dispatch(moveSectionDown({ item, mobileItem }));
        }
        else {
            showToast('Action failed!', 'warning');
        }
    }

    function handleDeleteClick() {
        dispatch(removeSection({ item, mobileItem }));
    }

    return (
        <section 
            onMouseEnter={() => setHoverOnBox(true)} 
            onMouseLeave={() => setHoverOnBox(false)} 
            className="embla relative" 
        >
            {
                buttonsVisible && 
                <div className="absolute -top-8 left-1/2 -translate-x-1/2 flex items-center rounded-md overflow-hidden bg-[#FFFFFF]">
                    <button onClick={handleEditClick} className='outline-none size-8 flex items-center justify-center'>
                        <img src={EditPencil} alt="" />
                    </button>
                    <button onClickCapture={handleUpClick} className='outline-none size-8 flex items-center justify-center'>
                        <img src={ArrowUp} alt="" />
                    </button>
                    <button onClick={handleDownClick} className='outline-none size-8 flex items-center justify-center'>
                        <img className='rotate-180' src={ArrowUp} alt="" />
                    </button>
                    <button onClick={handleDeleteClick} className='outline-none size-8 flex items-center justify-center'>
                        <img src={Delete} alt="" />
                    </button>
                </div>
            }

            <div className="embla__viewport" ref={emblaRef}>
                <div className="embla__container">
                    {item.item.imageLinkList?.map((slide, index) => {
                        return (
                            <div className="embla__slide w-full" key={index}>
                                <img className='w-full h-auto cursor-pointer' src={getCachedMediaUrl(slide.imageLink)} alt={slide.altText} />
                            </div>
                        )
                    })}
                </div>
            </div>

            <div className="embla__controls">
                <div className="embla__dots">
                    {scrollSnaps.map((_, index) => (
                        <DotButton
                            key={index}
                            className={'embla__dot'.concat(
                                index === selectedIndex ? ' embla__dot--selected' : ''
                            )}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
}

export default CarouselBannerDesktop;
